import {
  afterNextRender,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  ViewChild
} from "@angular/core";
import {Subscription} from "rxjs";

@Component({
  template: '' // Pusty template, aby Angular nie próbował renderować
})
export abstract class AbstractComponent implements OnDestroy {

  get height(): number {
    return this._height;
  }

  set height(value: number) {
    this._height = value;
  }

  @ViewChild('parent', {static: false})
  public parentDiv: ElementRef;
  public innerWidth: number;
  public windowWidth: number = typeof window !== 'undefined' ? window.innerWidth : 0;
  private _height: number = 0;
  protected subscriptions: Subscription[] = [];
  protected timeoutIds: ReturnType<typeof setTimeout>[] = [];
  protected animationFrameIds: number[] = [];

  protected constructor() {
    afterNextRender(() => {
      this.assignWindowWidth();
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.assignWindowWidth();
    this.calculateHeight();
  }

  public calculateHeight(): void {
    if (!this.parentDiv) {
      return;
    }
    this.innerWidth = this.parentDiv.nativeElement.clientWidth;
    this.height = this.innerWidth * 0.5625;
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.timeoutIds.forEach(timeoutId => {
      clearTimeout(timeoutId);
    });
    this.animationFrameIds.forEach((refId: number) => {
      cancelAnimationFrame(refId);
    })
  }

  assignWindowWidth(): void {
    this.windowWidth = window.innerWidth;
  }
}
